import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { SeoData } from './seo-data';
import { SeoService } from './seo.service';

@Injectable({ providedIn: 'root' })
export class SeoTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly seo = inject(SeoService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const seoData = this.findSeoData(snapshot.root);
    if (seoData) {
      this.title.setTitle(seoData.title);
      this.seo.apply(seoData, snapshot.url || '/');
      return;
    }
    const fallback = this.buildTitle(snapshot);
    if (fallback !== undefined) {
      this.title.setTitle(fallback);
    }
  }

  private findSeoData(route: ActivatedRouteSnapshot): SeoData | undefined {
    let current: ActivatedRouteSnapshot | null = route;
    let seo: SeoData | undefined;
    while (current) {
      const data = current.data['seo'] as SeoData | undefined;
      if (data) seo = data;
      current = current.firstChild;
    }
    return seo;
  }
}
